// extracted by mini-css-extract-plugin
export default {"container":"ContactIcons_container__Hfs86","icon":"ContactIcons_icon__d3sNh"};